<cll-dialog-layout>
    <cll-dialog-header>
        <cll-dialog-title>New message</cll-dialog-title>
        <cll-dialog-subtitle>Create a new message</cll-dialog-subtitle>
    </cll-dialog-header>
    <div class="dialog-detail">
        <div class="dialog-container-header">
            <cll-icon type="outlined" [size]="24">send</cll-icon>
            <span class="dialog-container-header-text">Send to</span>
        </div>
        <div>
            <cll-form-field label="Recipients" class="small-input">
                <cll-multi-select [options]="searchableUsersDataSource"
                [formControl]="messageFormGroup.controls.recipients" />
            </cll-form-field>
        </div>
        <hr class="add-new-divider">
        <div class="dialog-container-header">
            <cll-icon type="outlined" [size]="24">message</cll-icon>
            <span class="dialog-container-header-text">Message</span>
        </div>
        <div>
            <cll-form-field label="Subject">
                <input cllFormInput
                          [formControl]="messageFormGroup.controls.subject"/>
            </cll-form-field>
        </div>
        <div>
            <cll-form-field label="Message">
                <textarea cllFormInput
                          [formControl]="messageFormGroup.controls.content" rows="4"></textarea>
            </cll-form-field>
        </div>
    </div>
    <span class="dialog-divider"></span>
    <cll-dialog-footer>
        <button cll-button
                colour="variant"
                cllDialogClose>
            Cancel
        </button>
        <button cll-filled-button
                colour="secondary" (click)="create()">
            <cll-icon type="outlined">send</cll-icon>
            Send
        </button>
    </cll-dialog-footer>
</cll-dialog-layout>

